import { Component, type ReactNode } from 'react';
import { isChunkLoadError, reloadForNewVersion } from '../lib/chunkReload';

/**
 * Catches an error while a screen is drawn, so the person sees a message and a way out rather than a
 * blank page. A file that failed to load after a deploy reloads the page once, which picks up the new version.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, { error: Error | null }> {
  override state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override componentDidCatch(error: Error) {
    if (isChunkLoadError(error)) reloadForNewVersion();
  }

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="auth-page">
        <div className="card empty" role="alert">
          <b>{isChunkLoadError(this.state.error) ? 'A new version is available.' : 'Something went wrong.'}</b>{' '}
          {isChunkLoadError(this.state.error) ? 'Reload to continue.' : 'Reload the page to try again. Your work in the books is saved.'}{' '}
          <button className="btn primary" onClick={() => window.location.reload()}>Reload</button>
        </div>
      </div>
    );
  }
}
